// Default chat name colour for a Twitch chatter who never picked one.
//
// Twitch sends such users with an EMPTY `color` tag and leaves the client to
// choose. Twitch's own web chat picks a random palette colour per session, so
// there is nothing to match exactly; StreamNook needs a rule that is stable
// across sessions, viewers, the app and this hosted overlay. Chatterino's rule:
// Twitch's 15-colour palette indexed by the numeric user id.
//
// HAND-MIRRORED from the app's Rust: C:\StreamNook\src-tauri\src\services\
// default_name_color.rs (this file is not in scripts/sync-overlay.mjs). When
// either side changes, change the other and replay the Rust test vectors here.

export const TWITCH_NAME_PALETTE = [
  '#FF0000', // Red
  '#0000FF', // Blue
  '#00FF00', // Green
  '#B22222', // FireBrick
  '#FF7F50', // Coral
  '#9ACD32', // YellowGreen
  '#FF4500', // OrangeRed
  '#2E8B57', // SeaGreen
  '#DAA520', // GoldenRod
  '#D2691E', // Chocolate
  '#5F9EA0', // CadetBlue
  '#1E90FF', // DodgerBlue
  '#FF69B4', // HotPink
  '#8A2BE2', // BlueViolet
  '#00FF7F', // SpringGreen
] as const;

function byteSum(s: string): bigint {
  let acc = 0n;
  for (const b of new TextEncoder().encode(s)) acc += BigInt(b);
  return acc;
}

/** Palette entry for a chatter. `userId` is the Twitch numeric id; `fallbackName`
 *  only matters when the id is missing or not numeric (Twitch never sends that). */
export function defaultNameColor(userId: string, fallbackName: string): string {
  const id = userId.trim();
  // BigInt so a very large id never loses precision the way Number would; the
  // Rust side parses u64.
  const seed = /^\d+$/.test(id) ? BigInt(id) : byteSum(id === '' ? fallbackName : userId);
  return TWITCH_NAME_PALETTE[Number(seed % BigInt(TWITCH_NAME_PALETTE.length))];
}

/** The tag value as Twitch sent it, or the derived default when it is empty.
 *  Never changes a colour the user actually set. */
export function resolveNameColor(tag: string | undefined, userId: string, fallbackName: string): string {
  return tag && tag.trim() ? tag : defaultNameColor(userId, fallbackName);
}
